var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "message-action-menu" }, [
    _vm.feedbackStatus !== -1
      ? _c(
          "button",
          {
            staticClass: "action-button",
            class: { active: _vm.feedbackStatus === 1 },
            attrs: { disabled: _vm.isDisabled },
            on: { click: _vm.handleThumbsUp }
          },
          [
            _c("InlineSvg", {
              attrs: { src: "/images/icons-2025/thumbs-up.svg" }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.feedbackStatus !== 1
      ? _c(
          "button",
          {
            staticClass: "action-button",
            class: { active: _vm.feedbackStatus === -1 },
            attrs: { disabled: _vm.isDisabled },
            on: { click: _vm.handleThumbsDown }
          },
          [
            _c("InlineSvg", {
              attrs: { src: "/images/icons-2025/thumbs-down.svg" }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "action-button",
        attrs: { disabled: _vm.isDisabled },
        on: { click: _vm.handleRefresh }
      },
      [
        _c("InlineSvg", { attrs: { src: "/images/icons-2025/refresh-02.svg" } })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "action-button",
        attrs: { disabled: _vm.isDisabled },
        on: { click: _vm.handleCopy }
      },
      [
        !_vm.showCheckmark
          ? _c("InlineSvg", { attrs: { src: "/images/icons-2025/copy.svg" } })
          : _c("InlineSvg", { attrs: { src: "/images/icons-2025/check.svg" } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }